var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import simpleToggleHotKeyHandler from './utils/simpleToggleHotKeyHandler';
import { lazyLoad } from '@react-page/core';
function createBasePlugin(pluginDefintion) {
    var PluginButton = lazyLoad(function () {
        return import('./components/PluginButton');
    });
    var Button = function (props) { return (React.createElement(PluginButton, __assign({}, props, { config: pluginDefintion }))); };
    return {
        pluginDefintion: pluginDefintion,
        onKeyDown: pluginDefintion.onKeyDown || pluginDefintion.hotKey
            ? simpleToggleHotKeyHandler(pluginDefintion)
            : function (e, editor, next) { return next(); },
        hoverButtons: pluginDefintion.addHoverButton ? [Button] : [],
        toolbarButtons: pluginDefintion.addToolbarButton ? [Button] : [],
    };
}
export default createBasePlugin;
//# sourceMappingURL=createBasePlugin.js.map